// Package Imports
import { queryOptions, useMutation } from '@tanstack/react-query'

// Core Imports
import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'

// Module Imports
import {
  createAdminUser,
  deleteAdminUser,
  getAdminUserDetail,
  getAdminUsersList,
  updateAdminUserRoles,
} from '@/modules/admin/admin.service'
import type {
  TAdminUser,
  TCreateAdminUserRequest,
  TUpdateAdminUserRolesRequest,
} from '@/modules/admin/admin.types'

export const adminUsersListQueryOptions = () =>
  queryOptions({
    queryKey: ['adminUsersList'],
    queryFn: getAdminUsersList,
  })

export const adminUserDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['adminUserDetail', id],
    queryFn: () => getAdminUserDetail(id),
  })

export function useCreateAdminUser({
  onSuccess,
  onError,
}: TMutation<string, TResponseError, TCreateAdminUserRequest>) {
  return useMutation<string, TResponseError, TCreateAdminUserRequest>({
    mutationFn: createAdminUser,
    onSuccess,
    onError,
  })
}

export function useDeleteAdminUser({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, string>) {
  return useMutation<void, TResponseError, string>({
    mutationFn: deleteAdminUser,
    onSuccess,
    onError,
  })
}

export function useUpdateAdminUserRoles({
  onSuccess,
  onError,
}: TMutation<TAdminUser, TResponseError, TUpdateAdminUserRolesRequest>) {
  return useMutation<TAdminUser, TResponseError, TUpdateAdminUserRolesRequest>({
    mutationFn: updateAdminUserRoles,
    onSuccess,
    onError,
  })
}
